module.exports = __webpack_public_path__ + "img/second-section-1.cbca32b5.jpg";